// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { rectangleLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-rectangle-lines': IconRectangleLines;
    }
}

/**
 * The icon component for the 'rectangleLines' icon
 */
export class IconRectangleLines extends Icon {
    public constructor() {
        super(rectangleLines16X16);
    }
}

registerIcon('icon-rectangle-lines', IconRectangleLines);
export const iconRectangleLinesTag = 'nimble-icon-rectangle-lines';
